import xss from "xss";

import { scrollToTop } from '../utils/functions';

export default class MessageStorage {
  constructor(status) {
    this.text = '';
    this.hidden = true;
    this.status = status || {};
    this.errorMsg = "";
  }

  open(htmlId, identifier, txt) {
    const elem = document.querySelector("#" + htmlId + " " + identifier);
    const modal = document.querySelector("#" + htmlId + " .ser-modal .ser-infomsgbox");
    if (!elem || !modal) return;
    let top = Math.max(0, (elem.offsetTop || 0) - (window.scrollY || 0) - 54);
    modal.style.marginTop = (top + "px");
    this.text = xss(txt);
    this.hidden = false;
    scrollToTop();
  }

  openWarning(htmlId, identifier, txt, width, topForMsg) {
    const elem = document.querySelector("#" + htmlId + " " + identifier);
    const modal = document.querySelector("#" + htmlId + " .ser-modal .ser-infomsgbox");
    if (!elem || !modal) return;
    let top = Math.max(0, (elem.offsetTop || 0) - (window.scrollY || 0) - 54);
    modal.style.marginTop = (top + "px");
    modal.style.width = width;
    modal.style.top = topForMsg;
    this.text = xss(txt);
    this.hidden = false;
    scrollToTop();
  }

  close() {
    this.hidden = true;
  }

  fileMessage(status) {
    const { fileId, message, error } = status || {};
    this.status = {
      fileId: Number(fileId) || 0,
      message: !!message,
      error: !!error
    };
  }

  displayFileMessage(fileId) {
    if (this.status && this.status.fileId === (Number(fileId) || 0)) {
      return this.status.message;
    }
    return false;
  }

  displayFileError(fileId) {
    if (this.status && this.status.fileId === (Number(fileId) || 0)) {
      return this.status.error;
    }
    return false;
  }
}
